@if (
  owners?.get('0').get('riskProfil')?.get('patrimonyDistribution')?.value
    ?.length == 0 && derrors
) {
  <info [option]="optionInfo1"> vous devez choisir au moins une option </info>
}

<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="riskProfil">
                <div class="checkbox">
                  <pr-checkbox-group
                    [derrors]="derrors"
                    formControlName="patrimonyDistribution"
                    [options]="options"
                  >
                  </pr-checkbox-group>
                </div>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
